import { motion } from "framer-motion";
import MaskedLines from "./MaskedLines";
import { BRAND_TEXTURE } from "@/constants/images";

export default function BrandSection() {
    return (
        <section className="relative overflow-hidden py-16 lg:py-24">
            <img
                src={BRAND_TEXTURE}
                alt=""
                aria-hidden="true"
                className="absolute inset-0 h-full w-full object-cover opacity-25"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/85 to-ink/60" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink via-transparent to-ink" />

            <div className="relative z-10 mx-auto max-w-[1600px] px-5 lg:px-10">
                <div className="flex items-center gap-4">
                    <span className="h-[2px] w-10 bg-flame" />
                    <span className="font-mono-tech text-[11px] tracking-[0.3em] text-mist">
                        POZIȚIONARE
                    </span>
                </div>

                <MaskedLines
                    inView
                    stagger={0.12}
                    className="mt-8 font-display font-extrabold uppercase leading-[0.95] tracking-[-0.01em]"
                    lineClassName="text-[clamp(1.9rem,4.8vw,4.6rem)]"
                    lines={[
                        <>
                            PRECIZIE<span className="text-flame">.</span>
                        </>,
                        <>
                            EXPERIENȚĂ<span className="text-flame">.</span>
                        </>,
                        <>
                            TEHNOLOGIE<span className="text-flame">.</span>
                        </>,
                    ]}
                />

                <motion.p
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.9, delay: 0.35, ease: [0.16, 1, 0.3, 1] }}
                    className="mt-8 max-w-xl text-sm leading-relaxed text-mist lg:text-[15px]"
                >
                    Toate lucrările sunt realizate cu echipamente profesionale
                    și tehnologii diamantate de ultimă generație — pentru tăieri
                    curate, fără vibrații, cu volum redus de praf și zgomot.
                </motion.p>
            </div>
        </section>
    );
}